export default __webpack_public_path__ + "static/media/ic-blacklist-inactive.70682ae6.webp";